import { AxiosInstance } from 'axios';

import { Role } from './common.types';

const CommonServiceFactory = ({ HTTPProfileManager }: { HTTPProfileManager: AxiosInstance }) => {
  return {
    getRoles: (): Promise<Role[]> => HTTPProfileManager.get('roles').then((res) => res.data),
  };
};

export default CommonServiceFactory;
